// extracted by mini-css-extract-plugin
export var about = "layout-module--about--d085f";
export var base = "layout-module--base--8ff5b";
export var catalog = "layout-module--catalog--5a857";
export var events = "layout-module--events--be279";
export var fauxnav = "layout-module--fauxnav--be729";
export var gallery = "layout-module--gallery--f7972";
export var intro = "layout-module--intro--db580";